<template>
  <div>
    <b-card>
      <template slot="header">
        <b-card-title>
          <strong>{{title}}</strong>
          <p-button type="success" round size="sm" style="float:right;" @click.native="changePlan">Change Plan</p-button>
        </b-card-title>
        <p class="card-category mt-4 d-flex justify-content-between">
          <i class="text-dark">{{planDetail.title}}</i>
          <span class="text-muted">{{planDetail.cost}}</span>
        </p>
        <hr />
      </template>
      <template slot="default">
        <b-row>
          <b-col>
            <invoices @seeAllInvoices="seeAllInvoices"/>
          </b-col>
        </b-row>
        <b-loading :loading="stripeSubscriptionLoading || stripeInvoicesLoading" />
      </template>
    </b-card>
  </div>
</template>
<script>
import { mapGetters } from 'vuex'
import Invoices from './Invoices'

import ModalBus from '@/buses/modal'

export default {
  data() {
    return {
      title: "Your Plan",
      processing: false,
    }
  },
  computed: {
    ...mapGetters([
      'user',
      'stripeCustomer',
      'stripeSubscriptionLoading',
      'stripeInvoicesLoading',
    ]),
    planDetail: function() {
      if (!this.stripeCustomer || !this.user) return {}
      if (this.user.subscription_plan === 'developer') {
        return {
          title: 'Developer',
          cost: '$0 / mo'
        }
      } else {
        return {
          title: 'Business',
          cost: '$15 / mo'
        }
      }
    }
  },
  methods: {
    changePlan() {
      ModalBus.$emit('subscriptionPlansModal.open')
    },
    seeAllInvoices() {
      ModalBus.$emit('allInvoicesModal.open')
    },
  },
  components: {
    Invoices
  }
}
</script>
